// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import type { ProcedureDetail } from '../types/procedures';

export interface ProcedureValidationErrors {
  title?: string;
  procedureNumber?: string;
  classification?: string;
  equipmentType?: string;
  description?: string;
  procedure?: string;
}

/**
 * Single source of truth for the guided form's required fields — shared by
 * `ProcedureForm` (inline `invalid`/`invalidText` per field) and
 * `ProcedureViewPage` (disabling Submit), so the two can't drift apart.
 */
export function validateProcedure(procedure: ProcedureDetail): ProcedureValidationErrors {
  const errors: ProcedureValidationErrors = {};

  if (!procedure.title.trim()) errors.title = 'Title is required.';
  if (!procedure.procedureNumber.trim()) errors.procedureNumber = 'Procedure # is required.';
  if (!procedure.classification.trim()) errors.classification = 'Classification is required.';
  if (!procedure.equipmentType.trim()) errors.equipmentType = 'Equipment type is required.';
  if (!procedure.description.trim()) errors.description = 'Description of work is required.';
  if (procedure.procedure.length === 0) {
    errors.procedure = 'At least one procedure step is required.';
  } else if (procedure.procedure.some(step => !step.action.trim())) {
    errors.procedure = 'Every procedure step needs an action.';
  }

  return errors;
}

export function isProcedureValid(procedure: ProcedureDetail): boolean {
  return Object.keys(validateProcedure(procedure)).length === 0;
}
